import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lowest sample price from the live Stripe catalog — never a hard-coded figure.
export function useSamplesFromPrice() {
  const [price, setPrice] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/payments/catalog`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive || !d) return;
        const amounts = Object.values(d).map((x) => Number(x?.amount)).filter((n) => Number.isFinite(n) && n > 0);
        if (amounts.length) setPrice(Math.min(...amounts));
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return price;
}

export const openSamples = () => window.dispatchEvent(new CustomEvent("prism:open-samples"));
